import { useQuery } from '@tanstack/react-query';
import api from '../../http';

export interface GroupPermission {
	action: string;
	subject: string;
}

export interface GroupDTO {
	_id: string;
	name: string;
	permissions: GroupPermission[];
	hierarchyCount?: number;
	createdAt: string;
	updatedAt: string;
}

export interface PaginatedGroupsResponse {
	docs: GroupDTO[];
	totalDocs: number;
	limit: number;
	totalPages: number;
	page: number;
}

export interface UseGetGroupsParams {
	page?: number;
	limit?: number;
	enabled?: boolean;
}

export function useGetGroups({ page = 1, limit = 1000, enabled = true }: UseGetGroupsParams = {}) {
	const query = useQuery<PaginatedGroupsResponse>({
		queryKey: ['groups', page, limit],
		enabled,
		queryFn: async () => {
			const { data } = await api.get<PaginatedGroupsResponse>('/management/group/findAll', {
				params: { page, limit },
			});
			return data;
		},
	});

	return {
		...query,
		data: query.data?.docs ?? [],
		pagination: query.data
			? { totalDocs: query.data.totalDocs, totalPages: query.data.totalPages, page: query.data.page }
			: null,
	};
}
